import React from 'react';
import { useThemeTokens } from '../../theme/ThemeProvider';

const Card = ({ 
  children, 
  title,
  subtitle,
  padding = 'lg',
  shadow = 'md',
  borderRadius = 'lg',
  className = '',
  style = {},
  onClick,
  hoverable = false,
  ...props 
}) => {
  const { getComponent, getSpacing, getShadow, getBorderRadius, getColor, animations } = useThemeTokens();
  
  const cardComponent = getComponent('cards');
  
  const getPaddingValue = () => {
    switch (padding) {
      case 'none':
        return '0';
      case 'sm':
        return getSpacing('sm');
      case 'md':
        return getSpacing('md');
      case 'lg':
        return getSpacing('lg');
      case 'xl':
        return getSpacing('xl');
      case '2xl':
        return getSpacing('2xl');
      default:
        return getSpacing(padding) || padding;
    }
  };
  
  const cardStyles = {
    backgroundColor: getColor('neutral.white'),
    borderRadius: getBorderRadius(borderRadius),
    boxShadow: getShadow(shadow),
    padding: getPaddingValue(),
    border: 'none',
    transition: hoverable ? `all ${animations.duration.normal} ${animations.easing.easeInOut}` : 'none',
    cursor: onClick ? 'pointer' : 'default',
    ...style,
  };
  
  const hoverStyles = hoverable ? {
    ':hover': {
      transform: 'translateY(-2px)',
      boxShadow: getShadow('lg'),
    }
  } : {};
  
  const titleStyles = {
    ...cardComponent.title,
    marginTop: 0,
    marginBottom: subtitle ? getSpacing('xs') : getSpacing('md'),
  };
  
  const subtitleStyles = {
    ...cardComponent.text,
    fontSize: getSpacing('md'),
    color: getColor('neutral.mediumGray'),
    marginTop: 0,
    marginBottom: getSpacing('md'),
  };
  
  const handleClick = (e) => {
    if (onClick) {
      onClick(e);
    }
  };
  
  return (
    <div
      onClick={handleClick}
      style={cardStyles}
      className={`gaero-card ${hoverable ? 'hoverable' : ''} ${className}`}
      {...props}
    >
      {title && (
        <h3 style={titleStyles}>
          {title}
        </h3>
      )}
      {subtitle && (
        <p style={subtitleStyles}>
          {subtitle}
        </p>
      )}
      {children}
    </div>
  );
};

export default Card;
